var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport4D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5785 7.06028C10.1295 6.47197 9.54331 5.98956 8.88229 5.63657C8.20879 5.28359 7.47294 5.0718 6.71213 5.01297C5.95133 4.95413 5.17806 5.06003 4.46715 5.30712C3.75623 5.55421 3.09521 5.95426 2.55891 6.46021C2.0226 6.96615 1.59855 7.58976 1.33664 8.26044C1.06225 8.95464 0.96247 9.67238 1.01236 10.3901C1.07472 11.1079 1.29922 11.8138 1.67338 12.4374C2.04755 13.0728 2.55891 13.6141 3.18251 14.0376C3.40701 12.2609 4.26759 10.6019 5.60211 9.34292C6.94911 8.07218 8.69521 7.27208 10.5785 7.06028Z",
    fill: "url(#paint0_linear_6578_38532)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6032 6.68295C12.4888 5.43573 13.8358 4.5415 15.3823 4.17675C15.0206 3.51784 14.4843 2.97659 13.8233 2.58831C13.1623 2.20003 12.389 2 11.6157 2C10.8424 2 10.0692 2.20003 9.40814 2.58831C8.74712 2.97659 8.19834 3.51784 7.84912 4.17675C9.39567 4.5415 10.7427 5.43573 11.6282 6.68295H11.6032Z",
    fill: "url(#paint1_linear_6578_38532)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8683 8.26996C21.6064 7.58752 21.1824 6.97568 20.6461 6.46973C20.1098 5.96378 19.4487 5.56373 18.7378 5.31664C18.0144 5.06955 17.2536 4.96366 16.4928 5.02249C15.732 5.08132 14.9837 5.29311 14.3227 5.6461C13.6492 5.99908 13.0755 6.4815 12.6265 7.0698C14.5098 7.2816 16.2683 8.09346 17.6029 9.35245C18.9374 10.6114 19.798 12.2705 20.0225 14.0472C20.6461 13.6236 21.1574 13.0706 21.5316 12.447C21.9057 11.8116 22.1302 11.1174 22.1926 10.3996C22.255 9.6819 22.1427 8.9524 21.8808 8.28172L21.8683 8.26996Z",
    fill: "url(#paint2_linear_6578_38532)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3961 12.8806H13.5854V17.1164H14.3961C14.5957 17.1164 14.6705 17.0458 14.6705 16.8811V13.1277C14.6705 12.9512 14.5832 12.8924 14.3961 12.8924V12.8806Z",
    fill: "url(#paint3_linear_6578_38532)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8348 10.0463C15.4379 8.72853 13.5546 7.99902 11.584 7.99902C9.61342 7.99902 7.73012 8.74029 6.33324 10.0463C4.93636 11.3524 4.16309 13.1409 4.16309 14.9999C4.16309 16.859 4.94883 18.6357 6.33324 19.9535C7.73012 21.2713 9.61342 22.0008 11.584 22.0008C13.5546 22.0008 15.4379 21.2595 16.8348 19.9535C18.2317 18.6474 19.005 16.859 19.005 14.9999C19.005 13.1409 18.2192 11.3642 16.8348 10.0463ZM11.584 16.9178H10.9355V18.0591H9.55106V16.9178H7.04415V15.7176L9.2642 11.9289H10.7359L8.35373 15.8941H9.55106V14.694H10.9355V15.8941H11.584V16.9178ZM16.1239 17.0002C16.1239 17.6591 15.7622 18.0709 14.8268 18.0709H12.1203V11.9407H14.8268C15.7622 11.9407 16.1239 12.3408 16.1239 12.9997V17.0002Z",
    fill: "url(#paint4_linear_6578_38532)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6578_38532",
    x1: 2.58727,
    y1: 8.57806,
    x2: 12.031,
    y2: 16.4654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6578_38532",
    x1: 9.09746,
    y1: 3.85492,
    x2: 13.9318,
    y2: 9.98526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6578_38532",
    x1: 14.2145,
    y1: 8.58758,
    x2: 23.659,
    y2: 16.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6578_38532",
    x1: 13.7653,
    y1: 14.5584,
    x2: 15.5102,
    y2: 14.9108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6578_38532",
    x1: 6.62256,
    y1: 13.5452,
    x2: 21.25,
    y2: 25.7677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport4D);
export default __webpack_public_path__ + "static/media/support4d.c7c8ba0c544c249ed03a49c1bb6fb0c6.svg";
export { ForwardRef as ReactComponent };